import { render, staticRenderFns } from "./GhgSolutionResults.vue?vue&type=template&id=076cb92a&scoped=true"
import script from "./GhgSolutionResults.vue?vue&type=script&setup=true&lang=ts"
export * from "./GhgSolutionResults.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GhgSolutionResults.vue?vue&type=style&index=0&id=076cb92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076cb92a",
  null
  
)

/* custom blocks */
import block0 from "./GhgSolutionResults.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxImpactSolutionKindChip: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/impact/SolutionKindChip.vue').default,MetricsAssignmentSection: require('/home/runner/work/assessment-service/assessment-service/frontend/components/metrics/AssignmentSection.vue').default,Forecast: require('/home/runner/work/assessment-service/assessment-service/frontend/components/Forecast.vue').default,AssumptionsAndLimitations: require('/home/runner/work/assessment-service/assessment-service/frontend/components/AssumptionsAndLimitations.vue').default,IxCardGhgSolutionEvidenceList: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/card/GhgSolutionEvidenceList.vue').default})
